import {
  SR_API_ACTION_GET_USER_CHECK_AVAILABILITY_LISTINGS,
} from 'api/actionTypes';

export default async function getCheckAvailabilityListings({ state, apiClient }) {
  if (state.get(['checkAvailabilityByListingId'])) {
    return;
  }

  await apiClient.postWithState({
    action: SR_API_ACTION_GET_USER_CHECK_AVAILABILITY_LISTINGS,
    state: state,
    onSuccess(listings) {
      const checkAvailabilityByListingId = listings.reduce((acc, listingId) => ({
        ...acc,
        [listingId]: true,
      }), {});

      state.set(['checkAvailabilityByListingId'], checkAvailabilityByListingId);
    },
  });
}
